(function () {
  window.drsknnPricingBootLoaded = true;

  function bootPricingModule() {
    if (typeof window.openDrSknnPricingModal === "function") return true;
    if (!document.getElementById("drsknn-pricing-modal")) return false;

    var scripts = document.querySelectorAll("script");
    for (var i = 0; i < scripts.length; i += 1) {
      var source = scripts[i].textContent || "";
      if (
        source.indexOf("window.openDrSknnPricingModal") === -1 ||
        source.indexOf("drsknn-pricing-modal-tile") === -1 ||
        scripts[i].hasAttribute("data-drsknn-pricing-boot-source")
      ) {
        continue;
      }

      scripts[i].setAttribute("data-drsknn-pricing-boot-source", "true");
      var runner = document.createElement("script");
      runner.setAttribute("data-drsknn-pricing-boot-runner", "true");
      runner.text = source;
      document.head.appendChild(runner);
      runner.parentNode.removeChild(runner);
      return typeof window.openDrSknnPricingModal === "function";
    }

    return false;
  }

  function start() {
    var attempts = 0;
    var intervalId = null;

    function tryBoot() {
      attempts += 1;
      if (bootPricingModule() || attempts >= 80) {
        if (intervalId) window.clearInterval(intervalId);
      }
    }

    tryBoot();
    intervalId = window.setInterval(tryBoot, 250);

    new MutationObserver(function () {
      bootPricingModule();
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
}());
